module.exports = __webpack_public_path__ + "static/img/11.d9be48c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/11.png
// module id = REi9
// module chunks = 0